import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let image_id = useDataValue({
    context: 'patient_image',
    path: 'id',
    viewPath: props.viewPath,
  })
  let setSelectedImageId = useDataChange({
    context: 'gallery',
    path: 'image_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    setSelectedImageId(image_id)
  }
}
